import { Grid } from "@material-ui/core";
import { GridApi, GridReadyEvent, themeMaterial } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useGridDefinitions } from "../../../../../controls/ag-grid/components/GridDefinitions";
import { CustomLoadingOverlay } from "../../../../../controls/customLoader/CustomCircularProgress";
import { L3MechanicalModel } from "../../../models/L3MechanicalModel";
import { useGridStyles } from "../../../styles/gridStyles";
import { useTableData } from "./hooks";

type Props = {
	rows: L3MechanicalModel[];
	loadingGrid: boolean;
	OnSend?: Function;
};
export const TableL3Mechanical = ({ rows, loadingGrid, OnSend }: Props) => {
	const [gridApi, setGridApi] = useState<GridApi>();
	const classes = useGridStyles();
	const send_data = (data: L3MechanicalModel) => {
		if (OnSend) OnSend(data);
	};
	const { columns } = useTableData({ onSend: send_data });

	const onGridReady = (params: GridReadyEvent) => {
		setGridApi(params.api);
	};

	useEffect(() => {
		if (loadingGrid && gridApi) {
			gridApi.showLoadingOverlay();
		} else {
			gridApi?.hideOverlay();
		}
	}, [loadingGrid, gridApi]);
	return (
		<div>
			<Grid container>
				<Grid
					item
					style={{
						borderRadius: 10,
						height: "calc(100vh - 300px)",
						minHeight: "calc(100vh - 300px)",
						border: "1px solid #E0E0E0",
					}}
					xs={12}
					md={12}
				>
					<AgGridReact
						onGridReady={onGridReady}
						rowSelection="single"
						pagination={false}
						animateRows={true}
						singleClickEdit={true}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={rows}
						columnDefs={columns}
						loadingOverlayComponent={CustomLoadingOverlay}
					></AgGridReact>
				</Grid>
			</Grid>
		</div>
	);
};
